import { DatesAction, type DateState } from "@/types/dates";
import { Dispatch, createContext } from "react";

export const initialState: DateState = {
  dates: [],
  dateType: "FULL",
  ranges: [],
};

export const DatesContext = createContext<DateState>(initialState);
export const DatesDispatchContext = createContext<Dispatch<DatesAction>>(
  () => {},
);
